import { animate, style, transition, trigger } from '@angular/animations';

export const fadeBottomTop = trigger('fadeBottomTop', [
  transition(':enter', [
    style({opacity: 0, transform: 'translateY(70px)'}),
    animate('300ms cubic-bezier(0.35, 0, 0.25, 1)', style({opacity: 1, transform: 'none'})),
  ]),
]);

export const fadeTopBottom = trigger('fadeTopBottom', [
  transition(':enter', [
    style({opacity: 0, transform: 'translateY(-50px)'}),
    animate('300ms cubic-bezier(0.35, 0, 0.25, 1)', style({opacity: 1, transform: 'none'})),
  ]),
]);
